var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { FixedPositionType } from './fixed-position-type';
import { Component, Input, ViewChild, Inject } from '@angular/core';
import * as _ from 'lodash';
import { ConditionItemModel } from '../condition/condition-item-model';
import { ConditionType } from '../condition/condition-type';
import { BitConditionModel } from '../condition/bit/bit-condition-model';
import { WordConditionModel } from '../condition/word/word-condition-model';
import { VariableValueType } from '../condition/comm/variable-value-type';
import { RelationType } from '../condition/comm/relation-type';
import { ConditionHelper } from '../condition/comm/condition-helper';
import { ConditionSettingModalComponent } from '../condition/condition-setting-modal.component';
import { DiagramConsts } from '../../../diagram/diagram-consts';
import { VARIABLE_SERVICE } from '../../../core/variable/variable.service';
import { VariableVersion } from '../../../core/variable/variable-version';
import { ResizableElementSettingModal } from '../../base/resizable-element-setting-modal';
import { DisplayType } from './display-type';
var DisplaySettingComponent = /** @class */ (function (_super) {
    __extends(DisplaySettingComponent, _super);
    function DisplaySettingComponent(injector, displayTypeOptionService, bitConditionTypeOptionService, variableService, relationTypeOptionService, comparatorTypeOptionService, modalService, logicTypeOptionService) {
        var _this = _super.call(this, injector, 'displaySetting') || this;
        _this.bitConditionTypeOptionService = bitConditionTypeOptionService;
        _this.variableService = variableService;
        _this.relationTypeOptionService = relationTypeOptionService;
        _this.comparatorTypeOptionService = comparatorTypeOptionService;
        _this.modalService = modalService;
        _this.logicTypeOptionService = logicTypeOptionService;
        _this.isSizeEnable = true;
        _this.isLocationEnable = true;
        _this.isFixedPositionVisible = false;
        _this.isSameSize = false;
        _this.isAngle = true;
        _this.constValueType = VariableValueType.Constant;
        _this.getConditionType = ConditionHelper.getConditionType;
        _this.radioName = Math.random().toString(36).slice(2);
        _this.permissionsResult = { PermissionEnabled: false, PermissionList: [] };
        _this.displayTypes = displayTypeOptionService.getOptions();
        _this.logicTypes = _this.logicTypeOptionService.getOptions();
        _this.selectedTypeKey = _this.displayTypes[0].key;
        _this.isAwaysDisplay = true;
        return _this;
    }
    DisplaySettingComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        this.configureId = editedComponent.configureId;
        if (this.isSizeEnable) {
            if (editedComponent.model.data.width && editedComponent.model.data.height) {
                this.width = editedComponent.model.data.width;
                this.height = editedComponent.model.data.height;
            }
            else if (editedComponent.model.data.size) {
                this.loadSizeInfo(editedComponent.model.data);
            }
            else {
                this.width = 80;
                this.height = 32;
            }
        }
        this.model = editedComponent.model.data;
        var model = this.model;
        if (model.isAwaysDisplay == null) {
            model.isAwaysDisplay = true;
        }
        this.isAwaysDisplay = model.isAwaysDisplay;
        this.selectedTypeKey = this.isAwaysDisplay === true
            ? DisplayType.AlwaysDisplay : DisplayType.ConditionDisplay;
        this.conditionItems = [];
        _.each(model.conditionItems, function (item) {
            if (!item.condition.variableName) {
                item.condition.variableName = ' ';
            }
            if (!item.condition.variableVersion && !_.isNil(item.condition.dataSourceCode)) {
                _this.variableService.getVariableName(item.condition.dataSourceCode, item.condition.variableName, item.condition.variableGroupName).subscribe(function (value) {
                    item.condition.variableName = value.name;
                    item.condition.variableVersion = VariableVersion.variableVersion;
                    delete item.condition.variableGroupName;
                    delete item.condition.dataSourceCode;
                    _this.initConditions(item);
                });
            }
            else {
                _this.initConditions(item);
            }
        });
        if (this.isFixedPositionVisible === true) {
            if (editedComponent.model.data.fixedPositionType !== undefined) {
                this.fixedPositionType = editedComponent.model.data.fixedPositionType;
            }
            else {
                this.fixedPositionType = FixedPositionType.TopLeft;
            }
        }
        this.rotationAngel = editedComponent.model.rotateObject.angle ? editedComponent.model.rotateObject.angle : 0;
        this.permissionsResult = editedComponent.model.data.permissionsForDisplaySetting || { PermissionEnabled: false, PermissionList: [] };
        this.displayLogicEnabled = editedComponent.model.data.displayLogicEnabled || this.conditionItems.length > 0;
    };
    DisplaySettingComponent.prototype.initConditions = function (item) {
        this.conditionItems.push(_.cloneDeep(item));
        this.setConditionsType();
    };
    DisplaySettingComponent.prototype.save = function () {
        if (this.saveDisplayInfo()) {
            if (this.isSizeEnable) {
                this.saveSizeInfo();
                this.changeWidthsAndHeights();
            }
            this.saveLocationInfo();
            this.saveFixedPositionType();
            return true;
        }
        return false;
    };
    DisplaySettingComponent.prototype.changeWidthsAndHeights = function () {
        if (this.model.category !== DiagramConsts.elements.tableKey) {
            return;
        }
        var widths = _.cloneDeep(this.model.widths);
        var heights = _.cloneDeep(this.model.heights);
        var widthSum = widths.reduce(function (prev, cur) {
            return prev + cur;
        });
        var heightSum = heights.reduce(function (prev, cur) {
            return prev + cur;
        });
        for (var i = 0; i < widths.length; i++) {
            widths[i] = widths[i] / widthSum * (this.width - widths.length + 1);
        }
        for (var i = 0; i < heights.length; i++) {
            heights[i] = heights[i] / heightSum * (this.height - heights.length + 1);
        }
        this.saveComponentProperty('widths', widths);
        this.saveComponentProperty('heights', heights);
    };
    DisplaySettingComponent.prototype.onChangeDisplayOption = function (option) {
        // eslint-disable-next-line eqeqeq
        this.isAwaysDisplay = option.key == DisplayType.AlwaysDisplay ? true : false;
    };
    DisplaySettingComponent.prototype.checkVariablesName = function () {
        var _this = this;
        var result = true;
        _.each(this.conditionItems, function (item) {
            if (!item.condition.variableName
                || item.condition.variableName === ' ') {
                _this.selectedCondition = item;
                result = false;
            }
        });
        return result;
    };
    DisplaySettingComponent.prototype.saveDisplayInfo = function () {
        this.saving = true;
        this.currentDiagram.startTransaction('display settings');
        if (!this.isAwaysDisplay) {
            if (this.conditionItems.length === 0 && this.displayLogicEnabled) {
                this.message.warn(this.lc('NoneCondition'), this.lc('Note'));
                return false;
            }
            if (this.permissionsResult.PermissionEnabled && this.permissionsResult.PermissionList.length === 0) {
                this.message.warn(this.lc('MustChoosePermission'), this.lc('Note'));
                return false;
            }
            if (!this.displayLogicEnabled && !this.permissionsResult.PermissionEnabled) {
                this.message.warn(this.lc('MustChoosePermissionOrLogicalEnable'), this.lc('Note'));
                return false;
            }
            if (!this.checkVariablesName()) {
                this.message.warn(this.lc('VariableNameEmpty'), this.lc('Note'));
                return false;
            }
        }
        this.saveComponentProperty('isAwaysDisplay', this.isAwaysDisplay);
        this.saveComponentProperty('conditionItems', this.conditionItems);
        this.saveComponentProperty('permissionsForDisplaySetting', this.permissionsResult);
        this.saveComponentProperty('displayLogicEnabled', this.displayLogicEnabled);
        this.saveComponentProperty('angle', this.rotationAngel);
        this.currentDiagram.commitTransaction('display settings');
        return true;
    };
    DisplaySettingComponent.prototype.onAdd = function () {
        var newCondition = new ConditionItemModel(this.conditionItems.length, ConditionType.Bit, undefined, RelationType.And);
        this.showConditionModal(newCondition);
    };
    DisplaySettingComponent.prototype.onModify = function () {
        if (!this.selectedCondition) {
            return;
        }
        this.showConditionModal(this.selectedCondition);
    };
    DisplaySettingComponent.prototype.onDelete = function () {
        var _this = this;
        if (!this.selectedCondition) {
            return;
        }
        this.message.confirm(this.lc('SureToDelete'), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                var index_1 = _this.conditionItems.indexOf(_this.selectedCondition);
                _this.conditionItems = _this.conditionItems.filter(function (val, i) { return i !== index_1; });
                _this.selectedCondition = null;
                if (_this.conditionItems.length > 0) {
                    _this.conditionItems[0].relationType = RelationType.None;
                    for (var i = index_1; i < _this.conditionItems.length; i++) {
                        _this.conditionItems[i].index = _this.conditionItems[i].index - 1;
                    }
                }
            }
        });
    };
    DisplaySettingComponent.prototype.onRowDbSelect = function (data) {
        this.selectedCondition = data;
        this.showConditionModal(this.selectedCondition);
    };
    DisplaySettingComponent.prototype.setConditionsType = function () {
        _.forEach(this.conditionItems, function (item) {
            item = ConditionHelper.setPrototypeOf(item, ConditionItemModel.prototype);
            if (item.conditionType === ConditionType.Bit) {
                item.condition = ConditionHelper.setPrototypeOf(item.condition, BitConditionModel.prototype);
            }
            else if (item.conditionType === ConditionType.Word) {
                item.condition = ConditionHelper.setPrototypeOf(item.condition, WordConditionModel.prototype);
            }
        });
    };
    DisplaySettingComponent.prototype.setConditionItem = function (event) {
        if (!event) {
            return;
        }
        if (!event.condition) {
            return;
        }
        var items = this.conditionItems.slice();
        var index = items.indexOf(event);
        if (index === -1) {
            // add
            if (items.length === 0) {
                event.relationType = RelationType.None;
            }
            items.push(event);
        }
        else {
            // modify
            items[index] = event;
        }
        this.conditionItems = items;
        event = null;
    };
    DisplaySettingComponent.prototype.onPermissionChanged = function (permissionResult) {
        this.permissionsResult = permissionResult;
    };
    DisplaySettingComponent.prototype.changeDisplayLogicalControlCheck = function () {
        var _this = this;
        if (this.displayLogicEnabled === false && this.conditionItems.length > 0) {
            this.message.confirm(this.lc('SureToClearLogicSetting'), function (isConfirmed) {
                if (isConfirmed) {
                    _this.conditionItems = [];
                }
                else {
                    _this.displayLogicEnabled = true;
                }
            });
        }
    };
    DisplaySettingComponent.prototype.heightChanged = function (value) {
        if (this.isSameSize) {
            this.width = value;
        }
    };
    DisplaySettingComponent.prototype.widthChanged = function (value) {
        if (this.isSameSize) {
            this.height = value;
        }
    };
    // （change） ，当点的位置发生改变时，点的xy坐标也需要变化 即 这个点 是 旋转固定点（locationSpot）
    DisplaySettingComponent.prototype.changeFixedPositionType = function (data) {
        var width = this.model.width === undefined ? Number(this.width) : Number(this.model.width);
        var height = this.model.height === undefined ? Number(this.height) : Number(this.model.height);
        if (this.fixedPositionType === FixedPositionType.TopLeft || this.fixedPositionType === FixedPositionType.CenterLeft
            || this.fixedPositionType === FixedPositionType.BottomLeft) {
            this.leftPointChangeFixedPositionType(data, width, height);
        }
        else if (this.fixedPositionType === FixedPositionType.TopCenter || this.fixedPositionType === FixedPositionType.CenterCenter
            || this.fixedPositionType === FixedPositionType.BottomCenter) {
            this.centerPointChangeFixedPositionType(data, width, height);
        }
        else {
            this.rightPointChangeFixedPositionType(data, width, height);
        }
        this.fixedPositionType = data;
    };
    // 左半边三个点切换点位，更换点坐标
    DisplaySettingComponent.prototype.leftPointChangeFixedPositionType = function (data, width, height) {
        // 保存的点的位置 和 要切换到点的位置 的差
        switch (data - this.fixedPositionType) {
            case 0:
                break;
            case 1:
                this.locationX += width / 2;
                break;
            case 2:
                this.locationX += width;
                break;
            case 3:
                this.locationY += height / 2;
                break;
            case 4:
                this.locationX += width / 2;
                this.locationY += height / 2;
                break;
            case 5:
                this.locationX += width;
                this.locationY += height / 2;
                break;
            case 6:
                this.locationY += height;
                break;
            case 7:
                this.locationX += width / 2;
                this.locationY += height;
                break;
            case 8:
                this.locationX += width;
                this.locationY += height;
                break;
            case -1:
                this.locationX += width;
                this.locationY -= height / 2;
                break;
            case -2:
                this.locationX += width / 2;
                this.locationY -= height / 2;
                break;
            case -3:
                this.locationY -= height / 2;
                break;
            case -4:
                this.locationX += width;
                this.locationY -= height;
                break;
            case -5:
                this.locationX += width / 2;
                this.locationY -= height;
                break;
            case -6:
                this.locationY -= height;
                break;
        }
    };
    DisplaySettingComponent.prototype.centerPointChangeFixedPositionType = function (data, width, height) {
        switch (data - this.fixedPositionType) {
            case 0:
                break;
            case 1:
                this.locationX += width / 2;
                break;
            case 2:
                this.locationX -= width / 2;
                this.locationY += height / 2;
                break;
            case 3:
                this.locationY += height / 2;
                break;
            case 4:
                this.locationX += width / 2;
                this.locationY += height / 2;
                break;
            case 5:
                this.locationX -= width / 2;
                this.locationY += height;
                break;
            case 6:
                this.locationY += height;
                break;
            case 7:
                this.locationX += width / 2;
                this.locationY += height;
                break;
            case -1:
                this.locationX -= width / 2;
                break;
            case -2:
                this.locationX += width / 2;
                this.locationY -= height / 2;
                break;
            case -3:
                this.locationY -= height / 2;
                break;
            case -4:
                this.locationX -= width / 2;
                this.locationY -= height / 2;
                break;
            case -5:
                this.locationX += width / 2;
                this.locationY -= height;
                break;
            case -6:
                this.locationY -= height;
                break;
            case -7:
                this.locationX -= width / 2;
                this.locationY -= height;
                break;
        }
    };
    DisplaySettingComponent.prototype.rightPointChangeFixedPositionType = function (data, width, height) {
        switch (data - this.fixedPositionType) {
            case 0:
                break;
            case 1:
                this.locationX -= width;
                this.locationY += height / 2;
                break;
            case 2:
                this.locationX -= width / 2;
                this.locationY += height / 2;
                break;
            case 3:
                this.locationY += height / 2;
                break;
            case 4:
                this.locationX -= width;
                this.locationY += height;
                break;
            case 5:
                this.locationX -= width / 2;
                this.locationY += height;
                break;
            case 6:
                this.locationY += height;
                break;
            case -1:
                this.locationX -= width / 2;
                break;
            case -2:
                this.locationX -= width;
                break;
            case -3:
                this.locationY -= height / 2;
                break;
            case -4:
                this.locationX -= width / 2;
                this.locationY -= height / 2;
                break;
            case -5:
                this.locationX -= width;
                this.locationY -= height / 2;
                break;
            case -6:
                this.locationY -= height;
                break;
            case -7:
                this.locationX -= width / 2;
                this.locationY -= height;
                break;
            case -8:
                this.locationX -= width;
                this.locationY -= height;
                break;
        }
    };
    DisplaySettingComponent.prototype.showConditionModal = function (item) {
        var _this = this;
        var modalRef = this.modalService.show(ConditionSettingModalComponent, {
            initialState: {
                configureId: this.configureId,
                conditionItem: item
            },
            backdrop: 'static',
            class: 'condition-setting-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.setConditionItem(item);
            }
            onClosedSub.unsubscribe();
        });
    };
    __decorate([
        ViewChild('dataTable', { static: true })
    ], DisplaySettingComponent.prototype, "dataTable", void 0);
    __decorate([
        ViewChild('paginator', { static: false })
    ], DisplaySettingComponent.prototype, "paginator", void 0);
    __decorate([
        ViewChild('controlPermissionSetting', { static: false })
    ], DisplaySettingComponent.prototype, "controlPermissionSetting", void 0);
    __decorate([
        Input()
    ], DisplaySettingComponent.prototype, "isSizeEnable", void 0);
    __decorate([
        Input()
    ], DisplaySettingComponent.prototype, "isLocationEnable", void 0);
    __decorate([
        Input()
    ], DisplaySettingComponent.prototype, "isFixedPositionVisible", void 0);
    __decorate([
        Input()
    ], DisplaySettingComponent.prototype, "isSameSize", void 0);
    __decorate([
        Input()
    ], DisplaySettingComponent.prototype, "isAngle", void 0);
    DisplaySettingComponent = __decorate([
        Component({
            selector: 'display-setting',
            styles: [".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } ",
                ".display-setting-base{ .position-and-rotate{ width: 100%; } .position,.rotate{ width: calc(50% - 5px); } .position .fe-modal-content,.rotate .fe-modal-content{ height: 90px; } .rotate .fe-modal-content{ position: relative; } .position{ float: left; } .rotate{ float: right; } .position .flexem-form-body{ height: 90px; } .width-and-height{ height: 30px; width: 100%; } .width-and-height>div{ width: 50%; display: inline-block; max-width: 137px; } .width-and-height:nth-child(1){ margin-bottom: 10px; } .inline-block{ display: inline-block; } span.inline-block{ width: 20px; } input.inline-block{ width: 80px; height: 30px; } .width-and-height:nth-child(2){ margin-bottom: 0; } .rotate-body{ width: 64px; height: 64px; margin: 2px 10px;   position: relative; top: -5px;  } .rotate-border{ width: 54px; height: 54px; position: absolute; border: 1px solid #b5c2ca; top: 11px; left: 5px; } .rotate-top,.rotate-middle,.rotate-bottom{ width: 100%; height: 10px; display: flex; justify-content: space-between; align-items: center; } .rotate-middle,.rotate-bottom{ margin-top:16px;  } .rotate-top>div,.rotate-middle>div,.rotate-bottom>div{ width: 10px; height: 10px; } .rotate-body{ height: 66px; } .rotate-body input[type=radio]{ width: 10px; height: 10px; position: relative; } .rotate-body input[type=radio]::before{ width: 10px; height: 10px; background: white; border: 1px solid #b5c2ca; border-radius: 0; position: absolute; left: 0; top:0; } .rotate-body input[type=radio]::after{ top: 1px; left: 1px; } .rotate-body input[type=radio]:checked:before{ width: 10px; height: 10px; background: #3695ff; } .rotate-body input[type=radio]:checked:after{ top: 1px; left: 1px; } .angle{ width:130px; position: absolute; right: 10px; bottom: 10px; } .angle span{ width: 45px; line-height: 30px; font-size: 14px; } .angle input{ width: 80px; height: 30px; padding: 5px 10px; } .flexem-form-body{ position: relative; input{ padding: 0 5px; } } .primeng-datatable-container{ .ui-table-thead{ tr{ border-bottom: 0!important; } } th,td{ box-sizing: border-box; background: transparent; padding: 0 10px!important; line-height: 29px; } } .primeng-datatable-container .primeng-no-data{ box-sizing: border-box; padding: 5px 10px; height: 30px; } .ui-table-scrollable-body{ margin-top: -1px; } .btns button{ margin-right: 10px; } .btns{ margin: 10px 0;  } .margin-top-5{ margin-top: 5px; } .and-or-select{ font-size: 12px; color: #666666; height: 24px; width: 80px; } } "],
            template: "<div class=\"fe-modal-body element-setting-base display-setting-base\"> <div class=\"position-and-rotate clearfix\"> <div class=\"position\" [hidden]=\"!isSizeEnable&&!isLocationEnable\" [ngStyle]=\"{'width':!isFixedPositionVisible?'100%':'calc(50% - 5px)'}\"> <div class=\"fe-option-head\"> {{lc('Position')}} </div> <div class=\"fe-modal-content\"> <div *ngIf=\"isSizeEnable\" class=\"width-and-height clearfix\"> <div> <span class=\"inline-block\">{{lc(\"Width\")}}：</span> <input type=\"number\" name=\"Width\"  class=\"inline-block\" (change)=\"widthChanged($event.target.value)\" [(ngModel)]=\"width\"> </div> <div> <span class=\"inline-block\">{{lc(\"Height\")}}：</span> <input type=\"number\" name=\"Height\"  class=\"inline-block\" (change)=\"heightChanged($event.target.value)\" [(ngModel)]=\"height\"> </div> </div> <div class=\"width-and-height\" *ngIf=\"isLocationEnable\"> <div> <span class=\"inline-block\">X:</span> <input type=\"number\" name=\"LocationX\" class=\"inline-block\"  [(ngModel)]=\"locationX\"> </div> <div> <span class=\"inline-block\">Y:</span> <input type=\"number\" name=\"LocationY\" class=\"inline-block\"  [(ngModel)]=\"locationY\"> </div> </div>           </div> </div> <div class=\"rotate\" [hidden]=\"!isFixedPositionVisible\" [ngStyle]=\"{'width':!isSizeEnable&&!isLocationEnable?'100%':'calc(50% - 5px)'}\"> <div class=\"fe-option-head\"> {{lc('Rotation')}} </div> <div class=\"fe-modal-content\"> <div class=\"rotate-body\"> <div class=\"rotate-border\"> </div> <div class=\"rotate-top\"> <div> <input type=\"radio\" position=\"TopLeft\" name=\"position\" [checked]=\"fixedPositionType == 0\" [value]=\"0\" (change)=\"changeFixedPositionType(0)\"/> </div> <div> <input type=\"radio\" position=\"TopCenter\" name=\"position\" [value]=\"1\" [checked]=\"fixedPositionType == 1\" (change)=\"changeFixedPositionType(1)\"/> </div> <div> <input type=\"radio\" position=\"TopRight\" name=\"position\" [value]=\"2\" [checked]=\"fixedPositionType == 2\" (change)=\"changeFixedPositionType(2)\"/> </div> </div> <div class=\"rotate-middle\"> <div> <input type=\"radio\" position=\"CenterLeft\" name=\"position\" [value]=\"3\" [checked]=\"fixedPositionType == 3\" (change)=\"changeFixedPositionType(3)\"/> </div> <div> <input type=\"radio\" position=\"CenterCenter\" name=\"position\" [value]=\"4\" [checked]=\"fixedPositionType == 4\" (change)=\"changeFixedPositionType(4)\"/> </div> <div> <input type=\"radio\" position=\"CenterRight\" name=\"position\" [value]=\"5\" [checked]=\"fixedPositionType == 5\" (change)=\"changeFixedPositionType(5)\"/> </div> </div> <div class=\"rotate-bottom\"> <div> <input type=\"radio\" position=\"BottomLeft\" name=\"position\" [value]=\"6\" [checked]=\"fixedPositionType == 6\" (change)=\"changeFixedPositionType(6)\"/> </div> <div> <input type=\"radio\" position=\"BottomCenter\" name=\"position\" [value]=\"7\" [checked]=\"fixedPositionType == 7\" (change)=\"changeFixedPositionType(7)\"/> </div> <div> <input type=\"radio\" position=\"BottomRight\" name=\"position\" [value]=\"8\" [checked]=\"fixedPositionType == 8\" (change)=\"changeFixedPositionType(8)\"/> </div> </div> </div> <div class=\"angle\" *ngIf=\"isAngle\"> <span class=\"inline-block\">{{lc('Angel')}}：</span> <input type=\"number\" name=\"Angle\" class=\"inline-block\" [(ngModel)]=\"rotationAngel\"> </div> </div> </div>  </div> <div class=\"ShowOrHide\"> <div class=\"fe-option-head\"> {{lc('ShowOrHide')}} </div> <div class=\"fe-modal-content\"> <div class=\"fe-radio-select-header\"> <label *ngFor=\"let option of displayTypes\"> <input type=\"radio\" name=\"{{radioName}}\" [value]=\"option.key\" [(ngModel)]=\"selectedTypeKey\" (change)=\"onChangeDisplayOption(option)\" required /> <span>{{option.name}}</span> </label> </div> <div *ngIf=\"!isAwaysDisplay\"  class=\"fe-radio-select-body\"> <control-permission-setting #controlPermissionSetting [configureId]=\"configureId\" [permissionSettingResult]=\"permissionsResult\" (permissionChange)=\"onPermissionChanged($event)\"></control-permission-setting> <label> <input type=\"checkBox\" [(ngModel)]=\"displayLogicEnabled\" (change)=\"changeDisplayLogicalControlCheck()\" /> <span>{{lc(\"LogicalEnableSetting\")}}</span> </label> <div *ngIf=\"displayLogicEnabled\" class=\"margin-top-5 fe-form\"> <div class=\"align-items-center\"> <div class=\"primeng-datatable-container\"> <p-table #dataTable [value]=\"conditionItems\" scrollable=\"true\" scrollHeight=\"100px\" ScrollWidth=\"100%\" selectionMode=\"single\" [(selection)]=\"selectedCondition\" [responsive]=\"true\" [style]=\"{'Height':'110px'}\"> <ng-template pTemplate=\"header\"> <tr> <th style=\"width:105px\">{{lc('Logic')}}</th> <th>{{lc('Condition')}}</th> </tr> </ng-template> <ng-template pTemplate=\"body\" let-rowData let-record=\"$implicit\"> <tr [pSelectableRow]=\"rowData\" (dblclick)=\"onRowDbSelect(record)\" class=\"cursor-pointer\"> <td style=\"width: 105px\"> <div *ngIf=\"record.relationType==1 || record.relationType==2\"> <select class=\"and-or-select\"  name=\"relation\" [(ngModel)]=\"record.relationType\"> <option *ngFor=\"let option of logicTypes \" [value]=\"option.key \">{{option.name}}</option> </select> </div> </td> <td> <div *ngIf=\"getConditionType(record)==0\"> <span *ngIf=\"!record.condition.isBitwiseIndex\">{{record.condition.variableName}}</span> <span *ngIf=\"record.condition.isBitwiseIndex\">{{record.condition.variableName}} . {{record.condition.bitIndex}}</span> <span>=</span> <span>{{bitConditionTypeOptionService.getOptionNameByKey(record.condition.bitConditionLogic)}}</span> </div> <div *ngIf=\"getConditionType(record)==1\"> <span>{{record.condition.variableName}}</span> <span>{{comparatorTypeOptionService.getOptionNameByKey(record.condition.baseVariableValue.operator)}}</span> <span *ngIf=\"record.condition.baseVariableValue.valueType==1\">{{record.condition.baseVariableValue.variableName}}</span> <span *ngIf=\"record.condition.baseVariableValue.valueType==0\">{{record.condition.baseVariableValue.constValue}}</span> <span *ngIf=\"record.condition.realtionVariableValue\">{{relationTypeOptionService.getOptionNameByKey(record.condition.relationType)}}</span> <span *ngIf=\"record.condition.realtionVariableValue\">{{record.condition.variableName}}</span> <span *ngIf=\"record.condition.realtionVariableValue\">{{comparatorTypeOptionService.getOptionNameByKey(record.condition.realtionVariableValue?.operator)}}</span> <span *ngIf=\"record.condition.realtionVariableValue?.valueType==1\">{{record.condition.realtionVariableValue?.variableName}}</span> <span *ngIf=\"record.condition.realtionVariableValue?.valueType==0\">{{record.condition.realtionVariableValue?.constValue}}</span> </div> </td> </tr> </ng-template> </p-table> <div class=\"primeng-no-data\" *ngIf=\"!conditionItems.length\"> {{l('NoData')}} </div> </div> </div> <div class=\"btns\"> <button (click)=\"onAdd()\" type=\"button\" class=\"fe-btn fe-btn-small fe-btn-operate\">{{lc('AddNew')}}</button> <button (click)=\"onModify()\" type=\"button\" class=\"fe-btn fe-btn-small fe-btn-operate\">{{lc('Modify')}}</button> <button (click)=\"onDelete()\" type=\"button\" class=\"fe-btn fe-btn-small fe-btn-operate\">{{lc('Delete')}}</button> </div> </div> </div> </div> </div> </div> "
        }),
        __param(3, Inject(VARIABLE_SERVICE))
    ], DisplaySettingComponent);
    return DisplaySettingComponent;
}(ResizableElementSettingModal));
export { DisplaySettingComponent };
